import { QuestTypes } from "@/game/entities/config/quests/quest_types";
import { ref } from "vue";

type QuestAvailabilityUserStore = {
	readonly abTestGroup: string | null;
	setAbTestGroup(group: string): void;
};

const availabilityReady = ref<boolean>(false);

let getAbTestGroup: () => string | null = (): string | null => null;

export function initializeQuestAvailability(
	tutorialActive: boolean,
	userStore: QuestAvailabilityUserStore,
): void {
	if (tutorialActive && !userStore.abTestGroup) {
		//const group: "A" | "Z" = Date.now() % 2 === 0 ? "A" : "Z";
		userStore.setAbTestGroup("A");
	}

	getAbTestGroup = (): string | null => userStore.abTestGroup;

	availabilityReady.value = true;
}

export function isQuestAvailabilityReady(): boolean {
	return availabilityReady.value;
}

export function areStandardQuestsEnabled(): boolean {
	return availabilityReady.value && getAbTestGroup() !== "Z";
}

export function isStandardQuestType(type: QuestTypes): boolean {
	return (
		type === QuestTypes.MAIN ||
		type === QuestTypes.SIDE ||
		type === QuestTypes.DAILY
	);
}

export function isQuestTypeEnabled(type: QuestTypes): boolean {
	return !isStandardQuestType(type) || areStandardQuestsEnabled();
}
